'use client'

import { useState } from 'react'
import type { NavLink } from '@/db/schema'

export default function Navbar({
  navLinks,
  navButtonLink,
}: {
  navLinks: NavLink[]
  navButtonLink: string
}) {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-3 items-center px-4 py-3 md:flex md:justify-between">
        {/* Hamburger (mobile) */}
        <div className="md:hidden">
          <button
            type="button"
            className="grid grid-cols-3 gap-1"
            aria-label="Menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            {Array.from({ length: 9 }).map((_, i) => (
              <span key={i} className="block h-1.5 w-1.5 rounded-full bg-red-600" />
            ))}
          </button>
        </div>

        {/* Logo */}
        <a href="#" className="text-center text-xl font-bold text-red-600 md:text-left">
          ทางเข้าหวย
        </a>

        {/* Desktop nav links */}
        <ul className="hidden items-center gap-6 text-sm font-medium text-gray-700 md:flex">
          {navLinks.map((link) => (
            <li key={link.url}>
              <a href={link.url} className="transition-colors hover:text-red-600">
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA button */}
        <div className="flex justify-end">
          <a
            href={navButtonLink || '#'}
            className="rounded-full bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700"
          >
            ทางเข้าเว็บล่าสุด
          </a>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <ul className="border-t border-gray-100 bg-white px-4 py-3 md:hidden">
          {navLinks.map((link) => (
            <li key={link.url}>
              <a
                href={link.url}
                className="block py-2 text-sm font-medium text-gray-700 transition-colors hover:text-red-600"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  )
}